import React, { useEffect, useLayoutEffect } from 'react';
import { Box, Flex, Avatar, HStack, Text, IconButton, Button, Menu, MenuButton, MenuList, MenuItem, useDisclosure, useColorModeValue, Stack, Image, Icon } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useAuth } from '../auth/AuthProvider';
import { FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Links = [
  { title: 'บันทึกข้อมูลคนไข้รายวัน', target: '/' },
  { title: 'สถิติคนไข้รายเดือน', target: '/monthly' },
  { title: 'สถิติคนไข้รายปี', target: '/yearly' },
  { title: 'สถิติคนไข้ย้อนหลัง 12 เดือน', target: '/hist_12_months' },
  { title: 'กิจกรรม/บันทึกช่วยจำ', target: '/calendar_note' },
];

const NavLink = (props) => {
  const { children } = props;

  return (
    <Box
      as="a"
      px={2}
      py={1}
      rounded={'md'}
      color="white"
      _hover={{
        color: 'blue.600',
        bg: useColorModeValue('gray.200', 'gray.700'),
      }}
      href={props.target}>
      {children}
    </Box>
  );
};

export default function Navbar() {
  const navigate = useNavigate();
  const { user, checkUser, logout } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // useLayoutEffect runs synchronously after all DOM mutations
  useLayoutEffect(() => {
    if (checkUser() === null) {
      console.log('checkUser is null');
      if (!window.location.pathname.includes('/login')) {
        navigate('/login');
      }
    }
  }, []);

  return (
    <>
      {user && (
        <Box
          bgGradient="linear(to-b, blue.500, blue.600, blue.700)"
          px={4}
          position="sticky"
          top={0}
          zIndex="1000">
          <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
            <IconButton
              size={'md'}
              icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
              aria-label={'Open Menu'}
              display={{ md: 'none' }}
              onClick={isOpen ? onClose : onOpen}
            />
            <HStack spacing={8} alignItems={'center'}>
              <Flex justify={"center"}>
                <Image w="30px" src="/images/icon.png" />{user && <Text display={{ base: 'flex', md: 'none' }} ml={2} color="white">{user.department}</Text>}
              </Flex>
              <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
                {Links.map((link) => (
                  <NavLink key={link.title} target={link.target}>
                    {link.title}
                  </NavLink>
                ))}
              </HStack>
            </HStack>
            <Flex alignItems={'center'}>
              <Menu>
                <MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0}>
                  <Avatar p={1} size={'sm'} overflow="hidden">
                    <Icon as={FaUser} w={4} h={4} />
                  </Avatar>
                </MenuButton>
                <MenuList>
                  <MenuItem
                    key="timetale"
                    onClick={() => {
                      navigate('/timetable');
                    }}>
                    <Text fontSize={16}>รายชื่อแพทย์/ตารางตรวจ</Text>
                  </MenuItem>
                  <MenuItem
                    key="logout"
                    onClick={() => {
                      logout();
                      navigate('/login');
                    }}>
                    <Text fontSize={16}>Log out</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>

          {isOpen ? (
            <Box pb={4} display={{ md: 'none' }}>
              <Stack as={'nav'} spacing={4}>
                {Links.map((link) => (
                  <NavLink key={link.title} target={link.target}>
                    {link.title}
                  </NavLink>
                ))}
              </Stack>
            </Box>
          ) : null}
        </Box>
      )}
    </>
  );
}
